import createCache from '@emotion/cache';
import * as stylis from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

// Create rtl cache
export const cacheRtl = createCache({
	key: 'mui-rtl',
	stylisPlugins: [stylis.prefixer, rtlPlugin]
});

export const cacheLtr = createCache({
	key: 'mui-ltr'
});
